import React from 'react';

const NotificationFallback = (props) => {
  return <div>{'Notification content cannot be displayed.'}</div>;
};

NotificationFallback.propTypes = {};

export default NotificationFallback;
